import React from 'react';
import { cn } from './cn';

/**
 * A placeholder for content that is on its way.
 *
 * The alternative this replaces is not a spinner — it is an EMPTY STATE shown
 * before the data arrives. "No accounts connected" and a blank account picker
 * are both claims, and both were being made about a request that had not come
 * back yet. A skeleton makes the opposite claim, which is the true one:
 * something is coming, and roughly this much of it.
 *
 * Deliberately not animated with a sweeping gradient. This is a dark,
 * monochrome app; a light bar travelling across the screen is the most
 * eye-catching thing on it, and it appears on every single load. A slow pulse
 * says "waiting" without competing with the content it is standing in for.
 *
 * `aria-hidden`: the shape is decoration. The region it fills should carry
 * `aria-busy` so a screen reader is told once, rather than reading out eight
 * meaningless boxes.
 */
export const Skeleton = ({ className, ...props }) => (
  <div
    aria-hidden="true"
    className={cn('animate-pulse rounded-field bg-surface-raised', className)}
    {...props}
  />
);

/**
 * A skeleton shaped like a text line. `w` is a Tailwind width class, because
 * varying the widths is what stops a stack of them reading as a table.
 */
export const SkeletonText = ({ w = 'w-full', className }) => (
  <Skeleton className={cn('h-3', w, className)} />
);

export default Skeleton;
